import AdminApi from '../services/api';
import swal from 'sweetalert2';

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show', 'company'],

    data() {
        return {
            title: '',
            isLoading: false,
            selectedCompany: null,
            hasError: '',
            currentGreen: 0,
            currentWhite: 0,
            currentBlue: 0,
            greenVoucher : 0,
            blueVoucher : 0,
            whiteVoucher : 0,
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                this.selectedCompany = this.company;
                this.title = this.selectedCompany.name;
                this.currentGreen = this.company.vouchers.green;
                this.currentWhite = this.company.vouchers.white;
                this.currentBlue = this.company.vouchers.blue;
            }
        },
        salary: function(val, oldVal) {
            this.hasError = '';
        },
        cost: function(val, oldVal) {
            this.hasError = '';
        }
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeAddCuponsCompany')
            this.reset();
        },
        successUpdate(){
            this.$topnavbar.$emit('successAddCuponsCompany')
        },

        generateVoucher: generateVoucher,
        minusVoucher: minusVoucher,
        minusVoucherWith: minusVoucherWith,
        plusVoucher: plusVoucher,
        plusVoucherWith: plusVoucherWith,
        addCupons: addCupons,
        reset: reset,
    }
}



function generateVoucher() {
    var returnValue = "";
    if(this.greenVoucher > 0) returnValue += "VOUCHER_GREEN-"+this.greenVoucher+";";
    if(this.blueVoucher > 0) returnValue += "VOUCHER_BLUE-"+this.blueVoucher+";";
    if(this.whiteVoucher > 0) returnValue += "VOUCHER_WHITE-"+this.whiteVoucher+";";
    if(returnValue.isEmpty){
        return null;
    }else{
        return returnValue;
    }
}

function reset() {
    this.blueVoucher = 0;
    this.greenVoucher = 0;
    this.whiteVoucher = 0;
}



function addCupons(){
    let _self = this;
    const newModel = {
        blue: _self.blueVoucher ,
        green: _self.greenVoucher ,
        white: _self.whiteVoucher ,
    };
    _self.isLoading = true;
    AdminApiService.addVoucherToCompany(_self.selectedCompany.id, newModel)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successUpdate();
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom dodavanja."
        })
}

function plusVoucher(voucher) {
    switch (voucher) {
        case 'VOUCHER_BLUE': {
            this.blueVoucher++;
            break;
        }
        case 'VOUCHER_GREEN': {
            this.greenVoucher++;
            break;
        }
        case 'VOUCHER_WHITE': {
            this.whiteVoucher++;
            break;
        }
    }
}

function minusVoucherWith(voucher, value) {
    switch (voucher) {
        case 'VOUCHER_BLUE': {
            this.blueVoucher = this.blueVoucher - value;
            break;
        }
        case 'VOUCHER_GREEN': {
            this.greenVoucher = this.greenVoucher - value;
            break;
        }
        case 'VOUCHER_WHITE': {
            this.whiteVoucher = this.whiteVoucher - value;
            break;
        }
    }
}

function plusVoucherWith(voucher, value){
    switch (voucher) {
        case 'VOUCHER_BLUE': {
            this.blueVoucher = this.blueVoucher + value;
            break;
        }
        case 'VOUCHER_GREEN': {
            this.greenVoucher = this.greenVoucher + value;
            break;
        }
        case 'VOUCHER_WHITE': {
            this.whiteVoucher = this.whiteVoucher + value;
            break;
        }
    }
}

function minusVoucher(voucher) {
    switch (voucher) {
        case 'VOUCHER_BLUE': {
            this.blueVoucher--;
            break;
        }
        case 'VOUCHER_GREEN': {
            this.greenVoucher--;
            break;
        }
        case 'VOUCHER_WHITE': {
            this.whiteVoucher--;
            break;
        }
    }
}


// WEBPACK FOOTER //
// ./src/modals/AddCompanyCupons.js